import React from 'react';
import { IconFont } from '@src/features/common';
import Quill from 'quill';

type Props = ISFCDividerProps;

export interface ISFCDividerProps {
  quill?: Quill;
}

export function SFCDivider(props: Props) {
  const insertDivider = () => {
    if (props.quill) {
      const range = props.quill.getSelection(true);

      props.quill.insertEmbed(range.index, 'hr', true, 'user');
      props.quill.setSelection(range.index + 1, 0, 'silent');
    }
  };

  return (
    <button type="button" className="add-bar--btn" onClick={insertDivider}>
      <IconFont type="icon-e-divider" />
      <span className="button-item__tip">
        <p>插入分割线</p>
        <p>Markdown: --- 空格</p>
      </span>
    </button>
  );
}

export default SFCDivider;
